module.exports = __webpack_public_path__ + "img/add@3x.0c627dcb.png";